import { useState } from "react";
import { BookOpen, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";

export const downloadGuide = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export function GuideCard({ slug, title, description, path, compact = false }) {
  const [busy, setBusy] = useState(false);
  const onDownload = async () => {
    setBusy(true);
    try { await downloadGuide(path, `rospa-wm-${slug}-guide.pdf`); }
    catch { toast.error("Couldn't download the guide. Please try again."); }
    finally { setBusy(false); }
  };
  return (
    <div className={`rounded-2xl bg-white border border-slate-200 ${compact ? "p-5 flex items-center gap-4" : "p-6 flex flex-col"}`} data-testid={`guide-card-${slug}`}>
      <div className="h-12 w-12 rounded-xl bg-[#0F2744] flex items-center justify-center shrink-0">
        <BookOpen className="h-6 w-6 text-amber-400" />
      </div>
      <div className={`flex-1 min-w-0 ${compact ? "" : "mt-4"}`}>
        <h3 className="font-bold text-[#0F2744]">{title}</h3>
        <p className="text-sm text-slate-500 mt-1">{description}</p>
      </div>
      <Button onClick={onDownload} disabled={busy} className={`bg-[#0F2744] hover:bg-[#0B192C] text-white font-bold ${compact ? "" : "mt-5 w-full"}`} data-testid={`guide-download-${slug}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Download className="h-4 w-4 mr-1.5" /> Download PDF</>}
      </Button>
    </div>
  );
}
